export default __webpack_public_path__ + "static/media/pic.9cf08b93.svg";